import { Subject } from 'rxjs';
import { debug } from './debug';
import { TaskError } from './definitions';
const TAG = 'CancelableTask';
export class CancelableTask {
    get isCanceled() {
        return this._canceled;
    }
    constructor(operation) {
        this.operation = operation;
        this._subject = new Subject();
        this._canceled = false;
        this._executed = false;
    }
    /**
     * If canceled is called before the execute => do nothing
     * otherwise reject pending request
     * If canceled is called more than once, do nothing
     */
    cancel(withError) {
        if (!this._canceled) {
            debug(TAG, `Canceling operation`);
            this._canceled = true;
            const error = withError || TaskError.operationCancelled(this);
            this._subject.error(error);
        }
    }
    /**
     * If execute is called after cancel => return Operation cancelled exception
     * If already executing, return the current execution promise
     */
    execute() {
        if (!this._executed && !this._canceled) {
            this._executed = true;
            debug(`Start operation execution...`);
            this.operation().subscribe({
                next: (data) => {
                    // debug(TAG, `NEXT `, data);
                    this._subject.next(data);
                },
                error: (err) => {
                    this._subject.error(err);
                },
                complete: () => {
                    // debug(TAG, `COMPLETE! `);
                    this._subject.complete();
                },
            });
        }
        // else {
        //     debug(TAG, `Task is either canceled or already executed...`);
        // }
        return this._subject;
    }
    toObservable() {
        return this._subject;
    }
}
